import { useEffect, useRef, useState } from "react";

const SlidePhotosContainer = ({ photoArray, goToGallery }) => {
    const scrollContainerRef = useRef();
    const [isLeft, setIsLeft] = useState(true);
    const [isRight, setIsRight] = useState(true);

    const scrollLeft = () => {
        scrollContainerRef.current.scrollTo({
            left: scrollContainerRef.current.scrollLeft - 220,
            behavior: 'smooth'
        })
    };
    const scrollRight = () => {
        scrollContainerRef.current.scrollTo({
            left: scrollContainerRef.current.scrollLeft + 220,
            behavior: 'smooth'
        })
    };
    useEffect(() => {
        const handleScroll = () => {
            const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
            setIsLeft(scrollLeft === 0);
            setIsRight(scrollLeft + clientWidth >= scrollWidth - 1);
        };
        const scrollContainer = scrollContainerRef.current;
        scrollContainer.addEventListener("scroll", handleScroll);
        handleScroll();
        return () => scrollContainer.removeEventListener("scroll", handleScroll);
    }, [])
    return (
        <div className="w-full flex flex-row gap-2 items-center">
            <div className={`w-12 h-12 border rounded-xl hidden md:flex justify-center items-center pt-2 lg:ml-[-50px] z-10 ${isLeft ? 'text-neutral-200' : 'text-[#225424]'}`} onClick={scrollLeft}><i className="fi fi-rr-angle-small-left text-3xl"></i></div>
            {/* Photos */}
            <div className="w-full flex gap-4 justify-start items-center flex-nowrap overflow-x-auto hide-scrollbar" ref={scrollContainerRef} >
                {
                    photoArray && photoArray.length > 0 &&
                    photoArray.map((element, index) => {
                        return <div key={index} className="h-72 min-w-72 overflow-hidden rounded-xl md:cursor-pointer" onClick={() => goToGallery(index)}><img src={element.resizedUrl} alt="" className="object-cover w-full h-full" /></div>
                    })
                }
            </div>
            <div className={`w-12 h-12 border rounded-xl hidden md:flex justify-center items-center pt-2 lg:mr-[-50px] z-10 ${isRight ? 'text-neutral-200' : 'text-[#225424]'}`} onClick={scrollRight}><i className="fi fi-rr-angle-small-right text-3xl"></i></div>
        </div>
    )
}

export default SlidePhotosContainer;